module.exports = __webpack_public_path__ + "static/img/3.88ac196.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/5/1/sp/3.png
// module id = sX/9
// module chunks = 0